import * as Yup from 'yup'

export const schema = (t: (key: string) => string) => ({
  price: Yup.string().required(t('requiredMessage')),
  quantity: Yup.string().required(t('requiredMessage')),
  cost: Yup.string().required(t('requiredMessage')),
  package: Yup.string().required(t('requiredMessage')),
})
